import Vue from 'vue'
import VueSocketio from 'vue-socket.io'
import store from './../store'
import AppConfig from './config/AppConfig'

const GLOBAL_CONFIG = AppConfig.load()

Vue.use(
  new VueSocketio({
    debug: true,
    connection: GLOBAL_CONFIG.SOCKET_SERVER,
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
    },
  })
)
